export default __webpack_public_path__ + "static/media/LAB-1.bba2303e.jpg";